export default __webpack_public_path__ + "static/media/edit_18_dis.3e6ca16e.png";